// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"checkbox_Checkbox__EIfTb","checkBoxLabel":"checkbox_checkBoxLabel__obcKH"};